import { gql } from '@apollo/client';
/**
 * @fragment LanguageFragment
 * @since 1.0.0
 */
export const LanguageFragment = gql `
  fragment LanguageFragment on Language {
    id
    name
    code
    primary
    enabled
    createdAt
    updatedAt
  }
`;
